import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import IssueAttributesScrollableTooltipCell from '../issue-attributes/IssueAttributesScrollableTooltipCell';

class IssueTypesAdminAttributesTableCell extends PureComponent {
  getDefinitionNames() {
    const {issueTypeAttributes, issueAttributeDefinitions} = this.props;

    return issueTypeAttributes
      ? issueTypeAttributes
        .map(issueTypeAttribute => {
          if (isNullOrUndefined(issueTypeAttribute)) {
            return null;
          }
          return issueAttributeDefinitions[issueTypeAttribute.attributeDefinitionId]
            ? issueAttributeDefinitions[issueTypeAttribute.attributeDefinitionId].title
            : '';
        })
        .filter(name => !!name)
      : [];
  }

  render() {
    const definitionNames = this.getDefinitionNames();
    return <IssueAttributesScrollableTooltipCell options={definitionNames} container={this.props.container} />;
  }
}

IssueTypesAdminAttributesTableCell.displayName = 'IssueTypesAdminAttributesTableCell';

IssueTypesAdminAttributesTableCell.propTypes = {
  issueTypeAttributes: PropTypes.arrayOf(PropTypes.object).isRequired,
  issueAttributeDefinitions: PropTypes.object.isRequired,
  container: PropTypes.object.isRequired
};

export default IssueTypesAdminAttributesTableCell;
